import React, { useState } from "react";
import "./style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ComponenteLogin from "../components/ComponenteLogin/index.";

const LoginDesktop = ({ setAuthenticated }) => {
    return (
        <div className="tela-login">
            <div className="login-esquerda"></div>
            <div className="login-direita">
                <div className="direita-componente-login">
                    <ComponenteLogin setAuthenticated={setAuthenticated} />
                </div>
            </div>
        </div>
    );
};

export default LoginDesktop;
